<template>
  <div class="page-card">
    <el-card>
      <div slot="header">数据总览</div>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-card>
            <div>今日新增用户</div>
            <h2>{{ overview.todayUserRegister }}</h2>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card>
            <div>商家点击量</div>
            <h2>{{ overview.merchantClicks }}</h2>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card>
            <div>导航量</div>
            <h2>{{ overview.merchantNavigates }}</h2>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card>
            <div>优惠券核销量</div>
            <h2>{{ overview.couponUsed }}</h2>
          </el-card>
        </el-col>
      </el-row>

      <el-divider>优惠券与商家统计</el-divider>

      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="dateRange.start"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="dateRange.end"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchCouponStats">统计优惠券</el-button>
          <el-button @click="exportCoupon">导出优惠券明细</el-button>
          <el-button @click="exportMerchant">导出商家统计</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="16" style="margin-top: 16px;">
        <el-col :span="12">
          <el-card>
            <div slot="header">优惠券统计</div>
            <el-descriptions :column="1" size="small">
              <el-descriptions-item label="发放量">{{ couponStats.totalIssued }}</el-descriptions-item>
              <el-descriptions-item label="核销量">{{ couponStats.totalUsed }}</el-descriptions-item>
              <el-descriptions-item label="核销率">{{ couponStats.useRate }}</el-descriptions-item>
            </el-descriptions>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <div slot="header">商家点击/导航（占位示例）</div>
            <el-table :data="merchantStats" size="small" border>
              <el-table-column prop="name" label="商家" />
              <el-table-column prop="clickCount" label="点击量" />
              <el-table-column prop="navigateCount" label="导航量" />
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import request, { ADMIN_API_BASE } from '@/api/request'

export default {
  name: 'Dashboard',
  data() {
    return {
      overview: {
        todayUserRegister: 0,
        merchantClicks: 0,
        merchantNavigates: 0,
        couponUsed: 0
      },
      dateRange: {
        start: '',
        end: ''
      },
      couponStats: {
        totalIssued: 0,
        totalUsed: 0,
        useRate: '0%'
      },
      merchantStats: []
    }
  },
  created() {
    request.get('/stats/overview').then(res => {
      const data = res.data || res
      this.overview = Object.assign(this.overview, data || {})
    })
    this.fetchMerchantStats()
  },
  methods: {
    fetchMerchantStats() {
      request.get('/stats/merchant').then(res => {
        const data = res.data || res
        this.merchantStats = (data && data.items) || []
      })
    },
    fetchCouponStats() {
      const params = {}
      if (this.dateRange.start) params.start = this.dateRange.start
      if (this.dateRange.end) params.end = this.dateRange.end
      request.get('/stats/coupon', { params }).then(res => {
        const data = res.data || res
        this.couponStats = Object.assign(this.couponStats, data || {})
      })
    },
    exportCoupon() {
      const params = []
      if (this.dateRange.start) params.push(`start=${this.dateRange.start}`)
      if (this.dateRange.end) params.push(`end=${this.dateRange.end}`)
      const query = params.length ? `?${params.join('&')}` : ''
      window.open(`${ADMIN_API_BASE}/stats/export/coupon${query}`)
    },
    exportMerchant() {
      window.open(`${ADMIN_API_BASE}/stats/export/merchant`)
    }
  }
}
</script>

